import { Degree } from '../../../../../../domain/Degree';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageCosinePhiEvaluation {
  private readonly ruleName = 'Lv_Busbar_VoltageCosinePhi';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(voltageCosinePhi: number): EvaluationResultType<Degree> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageCosinePhi
    );
    const value = Degree.fromFloat(voltageCosinePhi);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
